module.exports = __webpack_public_path__ + "img/whatsapp.e8cfaf59.svg";